module.exports = __webpack_public_path__ + "img/topicDIYGardening.a6f11ead.webp";